/**
 * Formatuje termin wizyty do postaci „8 Sie 2026, 08:45” (pl).
 *
 * Akceptuje formaty przychodzące z Medfile/panelu:
 *  - "2026-08-08 8:45"
 *  - "2026-08-08 08:45:00"
 *  - "2026-08-08T08:45:00"
 * Zwraca pusty string, gdy nie da się sparsować.
 */

const MONTH_SHORT = ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'];

function pad(value) {
  return String(value).padStart(2, '0');
}

export function formatBookingDate(value) {
  if (!value) return '';

  const match = String(value)
    .trim()
    .match(/^(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{2})/);

  if (!match) return String(value);

  const [, year, month, day, hour, minute] = match;
  const monthLabel = MONTH_SHORT[Number(month) - 1] || month;

  return `${Number(day)} ${monthLabel} ${year}, ${pad(hour)}:${minute}`;
}

/**
 * Parsuje termin wizyty do obiektu Date (czas lokalny). Budujemy Date z pol,
 * a nie z Date.parse(string), zeby uniknac roznic miedzy przegladarkami przy
 * formacie ze spacja ("2026-08-08 08:45"). Zwraca null, gdy nie da sie sparsowac.
 */
export function parseBookingDate(value) {
  if (!value) return null;

  const match = String(value)
    .trim()
    .match(/^(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?/);

  if (!match) return null;

  const [, year, month, day, hour, minute, second] = match;
  const date = new Date(
    Number(year), Number(month) - 1, Number(day),
    Number(hour), Number(minute), Number(second || 0),
  );

  return Number.isNaN(date.getTime()) ? null : date;
}
